module.exports = __webpack_public_path__ + "static/media/4_citric_candy.d019ce78.jpg";